import CardCustom from "./Card";

export default CardCustom